var map = {
	"./sampang/Footer.js": [
		6356,
		890,
		658,
		270,
		356
	],
	"./sampanganimation/Footer.js": [
		5710,
		890,
		461,
		934,
		201
	],
	"./sampanganimation/components/Footer/Footer.js": [
		3227,
		461,
		962
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9272;
module.exports = webpackAsyncContext;